/* ================================================================
   PRODUCT DETAIL PAGE JS
================================================================ */

function initProductPage(sectionId, productId) {
  'use strict';

  var variantsData = JSON.parse(
    document.getElementById('pdp-variants-json-' + sectionId).textContent
  );
  var imagesData = JSON.parse(
    document.getElementById('pdp-images-json-' + sectionId).textContent
  );

  var form        = document.querySelector('[data-pdp-form]');
  var variantInput = form ? form.querySelector('[data-pdp-variant-id]') : null;
  var priceEl     = document.querySelector('[data-pdp-price-display]');
  var compareEl   = document.querySelector('[data-pdp-compare]');
  var atcBtn      = document.querySelector('[data-pdp-atc]');
  var mainImg     = document.getElementById('pdp-main-img');
  var thumbs      = document.querySelectorAll('[data-pdp-thumb]');
  var thumbsWrap  = document.querySelector('.pdp-gallery__thumbs');
  var prevBtn     = document.querySelector('[data-pdp-prev]');
  var nextBtn     = document.querySelector('[data-pdp-next]');
  var qtyInput    = document.querySelector('[data-pdp-qty]');
  var qtyDec      = document.querySelector('[data-pdp-qty-dec]');
  var qtyInc      = document.querySelector('[data-pdp-qty-inc]');


  var selectedOptions = {};
  var currentGalleryIdx = 0;

  /* ---- Init selected options from active swatches/pills ---- */
  document.querySelectorAll('.pdp-swatch.is-active, .pdp-pill.is-active').forEach(function (btn) {
    var idx = parseInt(btn.dataset.optIdx, 10);
    selectedOptions[idx] = btn.dataset.optVal;
  });

  updateOptionAvailability();

  /* ---- Option click ---- */
  document.querySelectorAll('.pdp-swatch, .pdp-pill').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(btn.dataset.optIdx, 10);
      var val = btn.dataset.optVal;
      selectedOptions[idx] = val;

      /* Update active state in same option group */
      document.querySelectorAll('[data-opt-idx="' + idx + '"]').forEach(function (b) {
        var active = b.dataset.optVal === val;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', String(active));
      });

      /* Update selected label */
      var labelEl = document.querySelector('[data-opt-selected="' + idx + '"]');
      if (labelEl) {
        var display = val.indexOf('_') !== -1 ? val.split('_').slice(1).join('_') : val;
        labelEl.textContent = display;
      }

      var matched = findVariant();
      if (matched) updateVariant(matched);

      updateOptionAvailability();
    });
  });

  function findVariant() {
    return variantsData.find(function (v) {
      return Object.keys(selectedOptions).every(function (idx) {
        var optKey = 'option' + (parseInt(idx, 10) + 1);
        return v[optKey] === selectedOptions[idx];
      });
    }) || null;
  }

  function updateOptionAvailability() {
    document.querySelectorAll('.pdp-swatch, .pdp-pill').forEach(function (btn) {
      var optIdx = parseInt(btn.dataset.optIdx, 10);
      var btnVal = btn.dataset.optVal;

      var isAvailable = variantsData.some(function (v) {
        var vVal = v['option' + (optIdx + 1)];
        if (vVal !== btnVal) return false;
        if (!v.available) return false;

        return Object.keys(selectedOptions).every(function (idxStr) {
          var otherOptIdx = parseInt(idxStr, 10);
          if (otherOptIdx === optIdx) return true;
          return v['option' + (otherOptIdx + 1)] === selectedOptions[otherOptIdx];
        });
      });

      btn.classList.toggle('is-disable', !isAvailable);

      var svg = btn.querySelector('svg');
      if (!isAvailable) {
        if (!svg) {
          btn.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="24" y1="0" x2="0" y2="24" stroke="#40484F" stroke-width="2" /></svg>');
        }
      } else {
        if (svg) svg.remove();
      }
    });
  }

  function formatMoney(cents) {
    return 'Rp' + Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function updateVariant(variant) {
    /* Variant ID */
    if (variantInput) variantInput.value = variant.id;

    /* Price */
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.classList.remove('price-hidden');
      } else {
        compareEl.classList.add('price-hidden');
      }
    }

    /* ATC availability */
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
    }

    /* URL update without reload */
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    /* Sync gallery to variant featured image */
    if (variant.featured_image && variant.featured_image.position) {
      var imgIdx = variant.featured_image.position - 1;
      if (imgIdx >= 0 && imgIdx < imagesData.length) {
        setGalleryImage(imgIdx);
      }
    }
  }

  /* ---- Gallery ---- */
  function keepThumbInView(thumb) {
    if (!thumbsWrap || !thumb) return;

    var targetLeft = thumb.offsetLeft - (thumbsWrap.clientWidth - thumb.offsetWidth) / 2;
    thumbsWrap.scrollTo({
      left: Math.max(0, targetLeft),
      behavior: 'smooth'
    });
  }

  function setGalleryImage(idx) {
    if (!imagesData[idx]) return;
    currentGalleryIdx = idx;
    if (mainImg) {
      // Fade out
      mainImg.style.opacity = '0';
      
      // Wait for CSS transition (200ms) before swapping src
      setTimeout(function () {
        mainImg.src = imagesData[idx].src;
        mainImg.alt = imagesData[idx].alt;
        
        // Fade back in when the new image is fully loaded
        mainImg.onload = function () { 
          mainImg.style.opacity = '1'; 
        };
        // Fallback for cached images that might not fire onload
        if (mainImg.complete) {
          mainImg.style.opacity = '1';
        }
      }, 200);
    }
    thumbs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === idx);
    });
    if (thumbs[idx]) {
      keepThumbInView(thumbs[idx]);
    }
  }

  thumbs.forEach(function (thumb, idx) {
    thumb.addEventListener('click', function () { setGalleryImage(idx); });
  });

  if (prevBtn) prevBtn.addEventListener('click', function () {
    setGalleryImage((currentGalleryIdx - 1 + imagesData.length) % imagesData.length);
  });
  if (nextBtn) nextBtn.addEventListener('click', function () {
    setGalleryImage((currentGalleryIdx + 1) % imagesData.length);
  });

  /* ---- Trackpad & Touch Swipe Gestures ---- */
  var mainGallery = document.querySelector('.pdp-gallery__main');
  if (mainGallery) {
    var isSwiping = false;
    var swipeCooldown = 400;

    mainGallery.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 15) {
        e.preventDefault();
        if (isSwiping) return;
        isSwiping = true;

        if (e.deltaX > 0) {
          setGalleryImage((currentGalleryIdx + 1) % imagesData.length);
        } else {
          setGalleryImage((currentGalleryIdx - 1 + imagesData.length) % imagesData.length);
        }

        setTimeout(function () {
          isSwiping = false;
        }, swipeCooldown);
      }
    }, { passive: false });

    var touchStartX = 0;
    var touchEndX = 0;

    mainGallery.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    mainGallery.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diffX = touchEndX - touchStartX;
      if (Math.abs(diffX) > 40) {
        if (diffX < 0) {
          setGalleryImage((currentGalleryIdx + 1) % imagesData.length);
        } else {
          setGalleryImage((currentGalleryIdx - 1 + imagesData.length) % imagesData.length);
        }
      }
    }, { passive: true });
  }


  /* ---- Quantity stepper ---- */
  if (qtyDec) qtyDec.addEventListener('click', function () {
    var v = parseInt(qtyInput.value, 10) || 1;
    if (v > 1) qtyInput.value = v - 1;
  });
  if (qtyInc) qtyInc.addEventListener('click', function () {
    var v = parseInt(qtyInput.value, 10) || 1;
    qtyInput.value = Math.min(99, v + 1);
  });

  /* ---- Cart Toast Popover Helper ---- */
  function showCartToast() {
    var toast = document.getElementById('cart-toast-popover');
    if (!toast) return;

    if (window.jQuery) {
      window.jQuery('html, body').animate({ scrollTop: 0 }, 400);
      var $toast = window.jQuery(toast);
      $toast.addClass('is-show');
      clearTimeout(showCartToast._timer);
      showCartToast._timer = setTimeout(function () {
        $toast.removeClass('is-show');
      }, 5000);
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
    toast.classList.add('is-show');
    clearTimeout(showCartToast._timer);
    showCartToast._timer = setTimeout(function () {
      toast.classList.remove('is-show');
    }, 5000);
  }

  /* ---- Add to Cart ---- */
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      if (!variantInput || !variantInput.value) return;
      var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
      atcBtn.classList.add('is-loading');
      atcBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantInput.value, quantity: qty })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data && data.description ? data.description : 'Could not add to cart.');
            return data;
          });
        })
        .then(function () {
          updateCartCount();
          showCartToast();
          atcBtn.textContent = 'ADDED!';
          setTimeout(function () { atcBtn.textContent = 'ADD TO CART'; }, 1800);
        })
        .catch(function (err) { alert(err.message || 'Could not add to cart. Please try again.'); })
        .finally(function () {
          atcBtn.classList.remove('is-loading');
          atcBtn.disabled = false;
        });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.header-action-btn__badge').forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        });
      });
  }



  /* ---- Accordion ---- */
  document.querySelectorAll('.pdp-accordion__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item   = trigger.closest('.pdp-accordion__item');
      var body   = item.querySelector('.pdp-accordion__body');
      var isOpen = item.classList.contains('is-open');

      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
      if (!isOpen) {
        body.removeAttribute('hidden');
      } else {
        body.setAttribute('hidden', '');
      }
    });
  });

  /* ---- Product Recommendations (YMAL) ---- */
  var recsWrap = document.querySelector('[data-recommendations-url]');
  if (recsWrap) {
    var recsUrl = recsWrap.dataset.recommendationsUrl;
    fetch(recsUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var track = doc.querySelector('.scroll-row--md, .product-grid, .products-grid');
        var recsContainer = document.getElementById('pdp-recs-' + sectionId);
        if (track && recsContainer) {
          recsContainer.innerHTML = track.innerHTML;
        }
      })
      .catch(function () {});
  }
}

